export default __webpack_public_path__ + "static/media/img2.4e7eb26a.jpg";